export enum LocalesEnum {
  RUS = 'ru',
  ENG = 'en',
}

export interface ILocalizedContent {
  [LocalesEnum.RUS]: string;
  [LocalesEnum.ENG]: string;
}
